import { cn } from "../../../../helpers/cn";
import React from "react";
import { useFollowingCoachesCoachCard } from "../../../../hooks/blogs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

type BlogTopicsCoachesWrapperProps = React.ComponentProps<"div">;

export const BlogTopicsCoachesWrapper = ({
  className,
  children,
  ...props
}: BlogTopicsCoachesWrapperProps) => {
  const isLogged = useSelector(
    (state: RootState) => state.user.value.loggedUser,
  );
  useFollowingCoachesCoachCard();

  if (isLogged) {
    return (
      <div className={cn("mt-8", className)} {...props}>
        {children}
      </div>
    );
  }
};
